import React, { useCallback, useEffect, useState } from "react";

//Internal Imports
import './ListadoHistorico.css';
import MenuLayout from "../../common/components/MenuLayout/MenuLayout";
import SearchText from "../../common/components/SearchText/SearchText";
import { COLORS } from "../../common/constants/colors";
import { GetFormsHistoric } from "../../services/survey";
import { useNavigate } from "react-router-dom";
import { IAnswer, IAnswerEntitySelected } from "../../interfaces/IAnswer";
import AnswerItem from "../../common/components/AnswerItem/AnswerItem";
import { useForm } from "../../contexts/form";
import { getError, openNotification, tryCatch } from "../../common/constants/Utilities";
import LabelNotFound from "../../common/components/Label/LabelNotFound";
import LoadingPage from "../../common/components/LoadingPage/LoadingPage";
import { useAuth } from "../../contexts/auth";
import { IPropsMenu } from "../../interfaces/IPropsMenu";




const ListadoHistorico: React.FC<IPropsMenu> = ({ menu }) => {
    const [searchV, setSearchV] = useState<string>('');
    const { answerEntitySelected, setAnswerEntitySelected } = useForm();
    const [listAnswer, setlistAnswer] = useState<IAnswer[]>([]);
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    //Method
    const getListSurveysFiltered = useCallback(() => {
        let surveysFiltered: IAnswer[] = [];
        const valueLowerCase = searchV.toLowerCase();

        if (!!valueLowerCase) {
            surveysFiltered = listAnswer.filter((list) =>
                list.nombre?.toLowerCase().includes(valueLowerCase))
        } else {
            surveysFiltered = listAnswer
        }

        return surveysFiltered;
    }, [searchV, listAnswer])

    //Method
    const goToEntitySurveided = (FormAnsweredID: number) => {
        let objSelectedAnswer: IAnswerEntitySelected = {
            formId: FormAnsweredID,
            answerId: undefined,
            fechaDesde: undefined,
            fechaHasta: undefined,
            formName: getListSurveysFiltered().find(x => x.formularioID === FormAnsweredID)?.nombre,
            listadoNombre: getListSurveysFiltered().find(x => x.formularioID === FormAnsweredID)?.listadoNombre
        };
        setAnswerEntitySelected(objSelectedAnswer);
        navigate(`/HistoricoEntidadUsuario`);
    }

    const getAnswer = () => {
        tryCatch(() => {
            setFormLoading(true);
            GetFormsHistoric().then(response => {
                setlistAnswer(response.data)

            })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setFormLoading(false));
        })
    }

    useEffect(() => {

        getAnswer();
    }, []);


    return (

        <MenuLayout currentPage={menu.nombre}>
            <div className="listAnswer_container">
                <SearchText
                    value={searchV}
                    active={true}
                    borderColor={COLORS.black_back_color5}
                    textColor={COLORS.black_text_color1}
                    placeholdercolor={COLORS.black_text_color4}
                    name={"search_table"}
                    onChange={setSearchV}
                    placeholder={"Buscar"}
                    backgroundcolor={COLORS.black_back_color5}
                    opacity={1}
                    props={{ collapsed: 'false' }}
                />

                <div className="listAnswer_sesion" style={{height: '530px', overflowY:'auto', padding:'10px'}}>

                    {formLoading.toString() === 'true'
                        ? <div className="loading-container"> <LoadingPage message="Cargando..." /></div>
                        : getListSurveysFiltered().length === 0 && <div className="loading-container"> <LabelNotFound message="No se encontró la busqueda." /></div>

                    }
                    {getListSurveysFiltered().map((answer: IAnswer) =>
                        <AnswerItem
                            active={true}
                            backgroundcolorheader={COLORS.blue_inactive(1)}
                            backgroundcolorbody={COLORS.blue_inactive(1)}
                            item={answer}
                            borderColor={COLORS.black_shadow_1}
                            props={{ collapsed: 'false' }}
                            textColor={COLORS.blue_main(1)}
                            method={() => goToEntitySurveided(answer.formularioID)}
                        />
                    )
                    }



                </div>
            </div>
        </MenuLayout>
    )

}
export default ListadoHistorico;